import {
  RainbowKitProvider,
  connectorsForWallets,
  darkTheme,
} from '@rainbow-me/rainbowkit'
import { useCallback, useState } from 'react'
import {
  ClearNotificationArg,
  NotificationArg,
} from '../../common/NotificationCard'
import {
  notificationMessageConstructor,
  NotificationFactory,
} from '../../common/NotificationFactory'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createConfig, http, WagmiProvider } from 'wagmi'
import { abstractTestnet, abstract } from 'viem/chains'
import {
  ledgerWallet,
  metaMaskWallet,
  phantomWallet,
} from '@rainbow-me/rainbowkit/wallets'
import { abstractWallet } from '@abstract-foundation/agw-react/connectors'
import { StakingContent } from './StakingContent'

const queryClient = new QueryClient()

const wagmiConfig = createConfig({
  chains: [abstract, abstractTestnet],
  connectors: connectorsForWallets(
    [
      {
        groupName: 'Wallet Providers',
        wallets: [metaMaskWallet, abstractWallet, phantomWallet, ledgerWallet],
      },
    ],
    {
      appName: 'CNC',
      projectId: '13456',
    }
  ),
  transports: {
    [abstract.id]: http(),
    [abstractTestnet.id]: http(),
  },
})

export const StakingContentContainer = () => {
  const [notifications, setNotifications] = useState<ClearNotificationArg[]>([])

  const addNotification = useCallback((args: NotificationArg) => {
    const { message, link, type } = args
    const payload = notificationMessageConstructor(message, link, type)

    // Don't add duplicate messages
    if (
      !notifications.find(
        (n) => n.message === payload.message && n.type === payload.type
      )
    ) {
      setNotifications((arr) => [
        ...arr,
        notificationMessageConstructor(message, link, type),
      ])
    }
  }, [])

  const clearNotification = useCallback((id: string) => {
    setNotifications((arr) => arr.filter((n) => n.id !== id))
  }, [])

  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider modalSize="compact" theme={darkTheme()}>
          <StakingContent addNotification={addNotification} />
          <NotificationFactory
            notificationsList={notifications}
            clearNotification={clearNotification}
          />
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  )
}
